import React, { useMemo } from "react";
import { Icon } from "@iconify/react";
import { getCardToolData } from "../../lib/cardTools";
import EmailSignatureTool from "./EmailSignatureTool";
import QrDownloadTool from "./QrDownloadTool";

function CardToolsPanel({ card, cardUrl, hasPlusPlan = false, onTrack }) {
  const toolData = useMemo(
    () => getCardToolData({ card, cardUrl }),
    [card, cardUrl],
  );

  return (
    <section className="space-y-4" aria-label="Strumenti Cards">
      <div className="rounded-xl bg-white p-4 shadow-2xl shadow-slate-950/15 ring-1 ring-slate-200 sm:p-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-cyan-50 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.08em] text-cyan-700 ring-1 ring-cyan-100">
              <Icon icon="mdi:toolbox-outline" className="text-sm" />
              Strumenti
            </p>
            <h3 className="mt-3 text-xl font-extrabold text-slate-950">
              Materiali pronti dalla tua Cards
            </h3>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
              Genera QR code e, con Cards Plus, crea una firma email usando i
              dati già salvati nella card.
            </p>
          </div>

          <nav
            className="grid gap-2 sm:grid-cols-2"
            aria-label="Vai agli strumenti"
          >
            <a
              href="#strumento-qr-code"
              onClick={() => onTrack?.("tool_anchor_click", { tool: "qr" })}
              className="inline-flex items-center justify-center gap-2 rounded-md bg-slate-100 px-4 py-3 text-sm font-extrabold text-[#13526f] transition hover:bg-cyan-50"
            >
              <Icon icon="mdi:qrcode" className="text-lg" />
              QR code
            </a>
            <a
              href="#strumento-firma-email"
              onClick={() =>
                onTrack?.("tool_anchor_click", { tool: "signature" })
              }
              className="inline-flex items-center justify-center gap-2 rounded-md bg-slate-100 px-4 py-3 text-sm font-extrabold text-[#13526f] transition hover:bg-cyan-50"
            >
              <Icon icon="mdi:email-edit-outline" className="text-lg" />
              Firma email Plus
            </a>
          </nav>
        </div>
      </div>

      <div
        id="strumento-qr-code"
        className="scroll-mt-6 rounded-xl bg-white p-4 shadow-2xl shadow-slate-950/15 ring-1 ring-slate-200 sm:p-6"
      >
        <div className="mb-5">
          <p className="inline-flex items-center gap-2 rounded-full bg-cyan-50 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.08em] text-cyan-700 ring-1 ring-cyan-100">
            <Icon icon="mdi:qrcode" className="text-sm" />
            QR code
          </p>
          <h3 className="mt-3 text-xl font-extrabold text-slate-950">
            QR code scaricabile
          </h3>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
            Scarica un QR code collegato alla URL pubblica della card.
          </p>
        </div>
        <QrDownloadTool data={toolData} onTrack={onTrack} />
      </div>

      <div
        id="strumento-firma-email"
        className="scroll-mt-6 rounded-xl bg-white p-4 shadow-2xl shadow-slate-950/15 ring-1 ring-slate-200 sm:p-6"
      >
        <div className="mb-5">
          <p className="inline-flex items-center gap-2 rounded-full bg-cyan-50 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.08em] text-cyan-700 ring-1 ring-cyan-100">
            <Icon icon="mdi:email-edit-outline" className="text-sm" />
            Firma email
          </p>
          <h3 className="mt-3 text-xl font-extrabold text-slate-950">
            Generatore firma HTML
          </h3>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
            Crea una firma compatibile con Gmail, Outlook e Apple Mail.
            Funzione disponibile con Cards Plus.
          </p>
        </div>
        {hasPlusPlan ? (
          <EmailSignatureTool data={toolData} onTrack={onTrack} />
        ) : (
          <div className="rounded-lg border border-amber-100 bg-amber-50 p-4">
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.08em] text-amber-700">
                  Riservato a Cards Plus
                </p>
                <p className="mt-1 text-sm font-semibold leading-6 text-slate-700">
                  Il generatore di firma email HTML è disponibile solo per le
                  card con piano Plus. Il QR code scaricabile resta disponibile
                  nel box precedente.
                </p>
              </div>
              <a
                href="mailto:cards@onoranzefunebricloud.com?subject=Attivazione%20Cards%20Plus"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-[#1b8395] px-4 py-3 text-sm font-bold text-white transition hover:bg-[#13526f]"
              >
                <Icon icon="mdi:star-plus-outline" className="text-lg" />
                Passa a Plus
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default CardToolsPanel;
